import { useEffect } from 'react'

import { directContactFormErrorIsAuthenticationError } from '../../direct-contact'
import { type OpenableControls } from '../../generic-hooks'
import { useDirectContactFormOrderAuthenticationContext } from '../context/DirectContactFormOrderAuthenticationContext'

export const useDirectContactFormOrderAuthenticationError = ({
  error,
  modalControls,
}: {
  error: unknown
  modalControls: OpenableControls
}): boolean => {
  const { handleClose } = modalControls
  const onOrderRequestAuthenticationError =
    useDirectContactFormOrderAuthenticationContext()
  const isAuthenticationError =
    directContactFormErrorIsAuthenticationError(error)

  useEffect(() => {
    if (!isAuthenticationError) {
      return
    }

    handleClose()
    onOrderRequestAuthenticationError()
  }, [handleClose, isAuthenticationError, onOrderRequestAuthenticationError])

  return isAuthenticationError
}
